import React, { useState } from 'react';

export default function MesurementViseObjection() {
  const [formData, setFormData] = useState({
    projectId: '',
    landOwnerName: '',
    contactNumber: '',
    taluka: 'Buldhana',
    village: '',
    surveyNo: '',
    measuredArea: '',
    claimedArea: '',
    objectionTrees: '',
    objectionStructures: '',
    objectionWaterBodies: '',
    objectionRemarks: '',
    attachSurveyPlan: false,
    attachPhotos: false,
  });
  const [surveyPlanFile, setSurveyPlanFile] = useState(null);
  const [photosFiles, setPhotosFiles] = useState(null);
  const [fileError, setFileError] = useState('');

  const projectOptions = ['Project A', 'Project B', 'Project C'];
  const talukaOptions = ['Buldhana', 'Jalgaon', 'Akola', 'Amravati'];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ 
      ...prev, 
      [name]: type === 'checkbox' ? checked : value 
    }));
  };

  const handleFileChange = (e, fileType) => {
    const files = e.target.files;
    setFileError('');

    if (files && files.length > 0) {
      let isValid = true;
      let totalSize = 0;
      
      // Check size of each file
      for (let i = 0; i < files.length; i++) {
        totalSize += files[i].size;
        if (files[i].size > 1024 * 1024) { // 1MB in bytes
          isValid = false;
          break;
        }
      }
      
      if (!isValid) {
        setFileError(`One or more files exceed 1MB size limit`);
        if (fileType === 'surveyPlan') {
          setSurveyPlanFile(null);
        } else {
          setPhotosFiles(null);
        }
      } else if (totalSize > 5 * 1024 * 1024) { // 5MB total limit
        setFileError(`Total file size exceeds 5MB limit`);
        if (fileType === 'surveyPlan') {
          setSurveyPlanFile(null);
        } else {
          setPhotosFiles(null);
        }
      } else {
        if (fileType === 'surveyPlan') {
          setSurveyPlanFile(files[0]);
        } else {
          setPhotosFiles(files);
        }
      }
    } else {
      if (fileType === 'surveyPlan') {
        setSurveyPlanFile(null);
      } else {
        setPhotosFiles(null);
      }
    }
  };

  const handleSubmit = () => {
    // Validation
    if (!formData.projectId) {
      alert('Please select a project.');
      return;
    }
    
    if (!formData.landOwnerName) {
      alert('Please enter the land owner name.');
      return;
    }
    
    if (formData.contactNumber.length !== 10) {
      alert('Contact number must be exactly 10 digits.');
      return;
    }
    
    if (!formData.village) {
      alert('Please enter the village name.');
      return;
    }
    
    if (!formData.surveyNo) {
      alert('Please enter the survey number.');
      return;
    }
    
    if (!formData.measuredArea || !formData.claimedArea) {
      alert('Please enter both measured and claimed areas.');
      return;
    }
    
    console.log('Submitted:', formData);
    console.log('Survey Plan File:', surveyPlanFile);
    console.log('Photos Files:', photosFiles);
    
    alert('Measurement objection form submitted successfully!');
  };

  return (
    <div className="space-y-8">
      {/* Basic Information */}
      <FormSection title="Basic Information" step={1}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Select label="Project" name="projectId" options={projectOptions} value={formData.projectId} onChange={handleChange} required />
          <Input label="Land Owner Name" name="landOwnerName" value={formData.landOwnerName} onChange={handleChange} required />
          <PhoneInput label="Contact Number" name="contactNumber" value={formData.contactNumber} onChange={handleChange} required />
          <Input 
            label="Objection Date" 
            name="objectionDate" 
            type="date" 
            value={new Date().toISOString().split('T')[0]} 
            readOnly 
            disabled
          />
        </div>
      </FormSection>
      
      {/* Land Details */}
      <FormSection title="Land Details" step={2}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Select label="Taluka" name="taluka" options={talukaOptions} value={formData.taluka} onChange={handleChange} required />
          <Input label="Village" name="village" value={formData.village} onChange={handleChange} required />
          <Input label="Survey No" name="surveyNo" value={formData.surveyNo} onChange={handleChange} required />
        </div>
      </FormSection>
      
      {/* Measurement Details */}
      <FormSection title="Measurement Details" step={3}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Input 
            label="Measured Area (in sq.m)" 
            name="measuredArea" 
            type="number" 
            value={formData.measuredArea} 
            onChange={handleChange} 
            required 
          />
          <Input 
            label="Claimed Area (in sq.m)" 
            name="claimedArea" 
            type="number" 
            value={formData.claimedArea} 
            onChange={handleChange} 
            required 
          />
        </div>
      </FormSection>
      
      {/* Specific Objections */}
      <FormSection title="Specific Objections" step={4}>
        <div className="grid grid-cols-1 gap-6">
          <Input label="Tree Objection Details" name="objectionTrees" value={formData.objectionTrees} onChange={handleChange} />
          <Input label="Structure Objection Details" name="objectionStructures" value={formData.objectionStructures} onChange={handleChange} />
          <Input label="Water Body Objection Details" name="objectionWaterBodies" value={formData.objectionWaterBodies} onChange={handleChange} />
          <Textarea label="Other Remarks" name="objectionRemarks" value={formData.objectionRemarks} onChange={handleChange} rows={4} />
        </div>
      </FormSection>
      
      {/* Attachments */}
      <FormSection title="Attachments" step={5}>
        <div className="space-y-6">
          <div className="flex flex-col">
            <Checkbox
              label="Attach Survey Plan"
              name="attachSurveyPlan"
              checked={formData.attachSurveyPlan}
              onChange={handleChange}
            />
            
            {formData.attachSurveyPlan && (
              <div className="mt-3 ml-6">
                <label className="text-sm font-medium text-gray-700 mb-1.5 block">
                  Upload Survey Plan <span className="text-red-500">*</span>
                  <span className="text-xs text-gray-500 ml-2">(Max size: 1MB)</span>
                </label>
                <input
                  type="file"
                  onChange={(e) => handleFileChange(e, 'surveyPlan')}
                  className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors w-full"
                  required={formData.attachSurveyPlan}
                />
                {surveyPlanFile && (
                  <p className="text-green-600 text-sm mt-1">
                    File uploaded: {surveyPlanFile.name} ({Math.round(surveyPlanFile.size / 1024)} KB)
                  </p>
                )}
              </div>
            )}
          </div>
          
          <div className="flex flex-col">
            <Checkbox
              label="Attach Photos"
              name="attachPhotos"
              checked={formData.attachPhotos}
              onChange={handleChange}
            />
            
            {formData.attachPhotos && (
              <div className="mt-3 ml-6">
                <label className="text-sm font-medium text-gray-700 mb-1.5 block">
                  Upload Photos <span className="text-red-500">*</span>
                  <span className="text-xs text-gray-500 ml-2">(Max size: 1MB per file, 5MB total)</span>
                </label>
                <input
                  type="file"
                  multiple
                  onChange={(e) => handleFileChange(e, 'photos')}
                  className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors w-full"
                  required={formData.attachPhotos}
                />
                {photosFiles && photosFiles.length > 0 && (
                  <p className="text-green-600 text-sm mt-1">
                    {photosFiles.length} file(s) uploaded
                  </p>
                )}
              </div>
            )}
          </div>
          
          {fileError && (
            <p className="text-red-500 text-sm font-medium">{fileError}</p>
          )}
        </div>
      </FormSection>
      
      {/* Submit Button */}
      <div className="flex justify-center pt-4">
        <button
          onClick={handleSubmit}
          className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-8 py-3 rounded-lg transition-colors duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-1"
        >
          Submit
        </button>
      </div>
    </div>
  );
}

// Form Section Component
function FormSection({ children, title, step }) {
  return (
    <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
      <h2 className="text-xl font-semibold mb-4 text-gray-800 flex items-center">
        <span className="bg-blue-600 text-white rounded-full w-7 h-7 flex items-center justify-center mr-2 text-sm">{step}</span>
        {title}
      </h2>
      {children}
    </div>
  );
}

// Input Component
function Input({ label, name, value, onChange, type = "text", required = false, readOnly = false, disabled = false }) {
  return (
    <div className="flex flex-col">
      <label htmlFor={name} className="text-sm font-medium text-gray-700 mb-1.5">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <input
        id={name}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        required={required}
        readOnly={readOnly}
        disabled={disabled}
        className={`border border-gray-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${disabled ? 'bg-gray-100' : ''}`}
      />
    </div>
  );
}

// Phone Input with +91
function PhoneInput({ label, name, value, onChange, required = true }) {
  return (
    <div className="flex flex-col">
      <label htmlFor={name} className="text-sm font-medium text-gray-700 mb-1.5">
        {label} (10-digit)
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <div className="flex items-center border border-gray-300 rounded-lg px-4 py-2.5 focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-transparent transition-colors">
        <span className="text-gray-500 mr-2 font-medium">+91</span>
        <input
          id={name}
          type="text"
          name={name}
          value={value}
          onChange={(e) => {
            const val = e.target.value.replace(/\D/g, '');
            if (val.length <= 10) {
              onChange({
                target: {
                  name,
                  value: val
                }
              });
            }
          }}
          required={required}
          className="w-full outline-none"
          placeholder="Enter mobile number"
        />
      </div>
    </div>
  );
}

// Textarea Component
function Textarea({ label, name, value, onChange, rows = 4, required = false }) {
  return (
    <div className="flex flex-col">
      <label htmlFor={name} className="text-sm font-medium text-gray-700 mb-1.5">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <textarea
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        rows={rows}
        required={required}
        className="border border-gray-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
      />
    </div>
  );
}

// Dropdown Select Component
function Select({ label, name, value, onChange, options, required = false }) {
  return (
    <div className="flex flex-col">
      <label htmlFor={name} className="text-sm font-medium text-gray-700 mb-1.5">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        className="border border-gray-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors bg-white"
      >
        <option value="">Select {label}</option>
        {options.map((opt, idx) => (
          <option key={idx} value={opt}>{opt}</option>
        ))}
      </select>
    </div>
  );
}

// Checkbox Component
function Checkbox({ label, name, checked, onChange }) {
  return (
    <div className="flex items-center">
      <input
        id={name}
        name={name}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
      />
      <label htmlFor={name} className="ml-2 block text-sm text-gray-700">
        {label}
      </label>
    </div>
  );
}